import axiosInstance from '../utils/AxiosConfig';

export const getBusinessUnits = async () => {
  const response = await axiosInstance.get('/business-units');
  return response.data.data;
};

export const createBusinessUnit = async (payload) => {
  const response = await axiosInstance.post('/business-units', payload);
  return response.data.data;
};

export const updateBusinessUnit = async (id, payload) => {
  const response = await axiosInstance.put(`/business-units/${id}`, payload);
  return response.data.data;
};

export const deleteBusinessUnit = async (id) => {
  const response = await axiosInstance.delete(`/business-units/${id}`);
  return response.data.data;
};
